import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { isValidCellUrl } from '@rivethealth/data/cell-resolver';
import Cookies from 'js-cookie';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '../common/core/environment';
import { API_CELL_URL_TEMPLATE, API_URL, ROUTER_API_URL } from './common';

export enum AuthPersistence {
  /** Persistent */
  PERSISTENT,
  /** Browser session */
  SESSION,
}

@Injectable({ providedIn: 'root' })
export class AuthStore {
  private tokenName = 'access_token';

  setTokenName(tokenName: string) {
    this.tokenName = tokenName;
  }
  getToken(): string | undefined {
    return (
      Cookies.get(this.tokenName) ||
      localStorage.getItem(this.tokenName) ||
      undefined
    );
  }

  deleteToken() {
    Cookies.remove(this.tokenName);
    localStorage.removeItem(this.tokenName);
  }

  setToken(token: string, persistence: AuthPersistence) {
    switch (persistence) {
      case AuthPersistence.PERSISTENT:
        Cookies.remove(this.tokenName);
        localStorage.setItem(this.tokenName, token);
        break;
      case AuthPersistence.SESSION:
        Cookies.set(this.tokenName, token);
        localStorage.removeItem(this.tokenName);
        break;
    }
  }
}

/**
 * Authenticate
 */
@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authStore: AuthStore,
    @Inject(API_URL) private readonly apiUrl: string,
    @Inject(ROUTER_API_URL) private readonly routerApiUrl: string,
    @Inject(API_CELL_URL_TEMPLATE) private readonly apiCellUrlTemplate: string,
    @Inject(ENVIRONMENT) private readonly environment: string,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      req.url.startsWith(this.apiUrl) ||
      req.url.startsWith(this.routerApiUrl) ||
      isValidCellUrl(this.environment, this.apiCellUrlTemplate, req.url)
    ) {
      const token = this.authStore.getToken();
      if (token !== undefined && !req.headers.has('Authorization')) {
        req = req.clone({
          headers: req.headers.set(
            'Authorization',
            `Bearer ${this.authStore.getToken()}`,
          ),
        });
      }
    }
    return next.handle(req);
  }
}
